<template>
  <dialog-base
    title="Thanh toán hàng loạt"
    :visible.sync="visible"
    size="md"
    :show-confirm="false"
    :show-cancel="false"
    :use-panel="false"
    @close="handleClose"
  >
    <div class="sk-dialog__content">
      <div class="sk-note sk-note--danger sk-u-mb-16">
        <i class="el-icon-warning-outline" />
        <span>Hệ thống sẽ tự động thanh toán toàn bộ số tiền còn nợ (nếu có) cho các phiếu thu đã chọn.</span>
      </div>

      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-s-finance" /></div>
          <div>
            <p class="sk-panel-title">Thông tin thanh toán</p>
            <p class="sk-panel-subtitle">Điền thông tin thanh toán cho các phiếu thu đã chọn</p>
          </div>
        </div>

        <el-form
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-position="top"
          label-width="auto"
        >
          <div class="sk-form-grid">
            <el-form-item label="Hình thức thanh toán" prop="paymentMethod">
              <el-radio-group v-model="formData.paymentMethod">
                <el-radio label="TM">Tiền mặt</el-radio>
                <el-radio label="CK">Chuyển khoản</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Tiền thừa thiếu" prop="transferMoneyType">
              <el-radio-group v-model="formData.transferMoneyType">
                <el-radio label="MONEY_WALLET">Không chuyển</el-radio>
                <el-radio label="MONEY_MONTH">Sang tháng sau</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="sk-form-grid">
            <el-form-item label="Người thanh toán" prop="parentPay">
              <el-input v-model="formData.parentPay" placeholder="Phụ huynh học sinh"></el-input>
            </el-form-item>
            <el-form-item label="Ngày thanh toán" prop="datePayment">
              <el-date-picker
                v-model="formData.datePayment"
                type="date"
                :clearable="false"
                class="sk-u-w-full"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </div>

          <el-form-item label="Mô tả" prop="noteHistory" class="sk-u-mt-12">
            <el-input type="textarea" :rows="2" v-model="formData.noteHistory" placeholder="Nhập mô tả"></el-input>
          </el-form-item>

          <el-form-item class="sk-u-mt-12">
            <el-checkbox v-model="formData.statusSendNotify">
              Gửi thông báo thanh toán qua App
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <template #footer>
      <div class="sk-dialog-footer">
        <el-button plain @click="handleClose">
          <i class="el-icon-circle-close" /> Hủy
        </el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit"
        >
          <i class="el-icon-circle-check" /> Thanh toán
        </el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import moment from "moment";

export default {
  name: "BatchPaymentDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
      loading: false,
      idxList: [],
      idKidList: [],
      formData: {
        paymentMethod: "CK",
        parentPay: "PHHS",
        datePayment: moment(new Date()).format("YYYY-MM-DD"),
        transferMoneyType: "MONEY_WALLET",
        noteHistory: "",
        statusSendNotify: false,
      },
      rules: {
        parentPay: [
          { required: true, message: "Người thanh toán không được để trống", trigger: "blur" }
        ],
        datePayment: [
          { required: true, message: "Ngày thanh toán không được để trống", trigger: "change" }
        ],
        paymentMethod: [
          { required: true, message: "Hình thức thanh toán không được để trống", trigger: "change" }
        ],
        transferMoneyType: [
          { required: true, message: "Tiền thừa thiếu không được để trống", trigger: "change" }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    open(idxList, idKidList) {
      if (!idxList || idxList.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn ít nhất 1 phiếu thu");
        return;
      }
      this.idxList = idxList;
      this.idKidList = idKidList || [];
      this.resetForm();
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$emit("closed");
    },
    resetForm() {
      this.formData = {
        paymentMethod: "CK",
        parentPay: "PHHS",
        datePayment: moment(new Date()).format("YYYY-MM-DD"),
        transferMoneyType: "MONEY_WALLET",
        noteHistory: "",
        statusSendNotify: false,
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async handleSubmit() {
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) return;

      this.$confirm(
        `Bạn có chắc chắn muốn thanh toán cho ${this.idxList.length} phiếu thu đã chọn?`,
        "Xác nhận thanh toán hàng loạt",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Có",
          cancelButtonText: "Không",
        }
      ).then(async () => {
        this.loading = true;
        try {
          const requestBody = {
            idxList: this.idxList,
            idKidList: this.idKidList,
            parentPay: this.formData.parentPay,
            datePayment: this.formData.datePayment,
            transferMoneyType: this.formData.transferMoneyType,
            noteHistory: this.formData.noteHistory,
            statusSendNotify: this.formData.statusSendNotify,
            paymentMethod: this.formData.paymentMethod,
          };
          const res = await ManagingStudentInvoiceService.batchPayInvoices(requestBody);
          if (res.data && res.data.data) {
            NotifyMessage.leftCornerNotificationSuccess("Thanh toán hàng loạt thành công");
            this.handleClose();
            this.$emit("saved");
          } else {
            NotifyMessage.leftCornerNotificationError("Thanh toán thất bại");
          }
        } catch (err) {
          console.error(err);
          NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi khi thanh toán hàng loạt"
          );
        } finally {
          this.loading = false;
        }
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";

.sk-u-mb-16 {
  margin-bottom: 16px;
}
.sk-u-w-full {
  width: 100%;
}
</style>
